// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2395":"345ae45a","2759":"5cf61029","3323":"fb758a4c","3380":"fee853f2","4181":"c419049d","6861":"28987a4f"}[chunkId] + ".chunk.css";
};